import { Link } from "@tanstack/react-router";
import { IoDocumentTextOutline, IoGridOutline } from "react-icons/io5";
import { LuLink, LuClipboardCheck } from "react-icons/lu";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { SidebarShell } from "./SidebarShell";

const sideListStyle =
  "flex items-center justify-start rounded-md px-4 py-4 gap-3 text-white hover:opacity-80 data-[status='active']:bg-white data-[status='active']:text-subcolor data-[status='active']:font-bold whitespace-nowrap";

type Props = {
  licenseId: string;
};

export function CompetitionDetailSidebar({ licenseId }: Props) {
  return (
    <SidebarShell>
      <li className="px-[10px] py-[5px]">
        <Link to="/competitions" activeOptions={{ exact: true }} className={sideListStyle}>
          <IoGridOutline size={18} /><span>コンペティション一覧</span>
        </Link>
      </li>
      <li className="px-[10px] py-[5px]">
        <Link to="/competitions/$licenseId/info" params={{ licenseId }} className={sideListStyle}>
          <IoDocumentTextOutline size={18} /><span>概要</span>
        </Link>
      </li>
      <li className="px-[10px] py-[5px]">
        <Link to="/competitions/$licenseId/data" params={{ licenseId }} className={sideListStyle}>
          <LuLink size={18} /><span>関連データ</span>
        </Link>
      </li>
      <li className="px-[10px] py-[5px]">
        <Link to="/competitions/$licenseId/score" params={{ licenseId }} className={sideListStyle}>
          <LuClipboardCheck size={18} /><span>リーダーボード</span>
        </Link>
      </li>
      <li className="px-[10px] py-[5px]">
        <Link to="/competitions/$licenseId/submission" params={{ licenseId }} className={sideListStyle}>
          <HiOutlinePencilAlt size={18} /><span>投稿</span>
        </Link>
      </li>
    </SidebarShell>
  );
}
